module.exports = __webpack_public_path__ + "img/4eb173822f083d17bb5d155203bfc7f2.png";